import React from 'react';
import { Table, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { Department, ModuleOption } from '../../../services/organizationAPI';
import { useDepartmentTableColumns } from './DepartmentTableColumns';

interface DepartmentTabProps {
    departments: Department[];
    modules: ModuleOption[];
    onAdd: () => void;
    onEdit: (dept: Department) => void;
    onDelete: (id: number) => void;
}

export const DepartmentTab: React.FC<DepartmentTabProps> = ({
    departments,
    modules,
    onAdd,
    onEdit,
    onDelete,
}) => {
    const columns = useDepartmentTableColumns({ modules, onEdit, onDelete });

    return (
        <>
            <div style={{ marginBottom: 16 }}>
                <Button type="primary" icon={<PlusOutlined />} onClick={onAdd}>
                    新建部门
                </Button>
            </div>
            <Table
                columns={columns}
                dataSource={Array.isArray(departments) ? departments : []}
                rowKey="id"
                pagination={false}
            />
        </>
    );
};

export default DepartmentTab;
